import { BackgroundModel } from 'src/app/engine/models/background.model';

export const appDefaultBackground: BackgroundModel = {
  colors: [245, 245, 245, 1, 245, 245, 245, 1],
  gradientType: 'radial',
  colorStops: [0, 100]
  
};

export const transparentBackground: BackgroundModel = {
  colors: [255, 255, 255, 0, 255, 255, 255, 0],
  gradientType: 'linear',
  colorStops: [0, 100]
};

export const studioSwatch: BackgroundModel[] = [
  // grayscale: solid
  {
    colors: [0, 0, 0, 1, 0, 0, 0, 1],
    gradientType: 'linear',
    colorStops: [0, 100]
  },
  {
    colors: [38, 38, 38, 1, 38, 38, 38, 1],
    gradientType: 'linear',
    colorStops: [0, 100]
  },
  {
    colors: [77, 77, 77, 1, 77, 77, 77, 1],
    gradientType: 'linear',
    colorStops: [0, 100]
  },
  {
    colors: [115, 115, 115, 1, 115, 115, 115, 1],
    gradientType: 'linear',
    colorStops: [0, 100]
  },
  {
    colors: [153, 153, 153, 1, 153, 153, 153, 1],
    gradientType: 'linear',
    colorStops: [0, 100]
  },
  {
    colors: [191, 191, 191, 1, 191, 191, 191, 1],
    gradientType: 'linear',
    colorStops: [0, 100]
  },
  {
    colors: [230, 230, 230, 1, 230, 230, 230, 1],
    gradientType: 'linear',
    colorStops: [0, 100]
  },
  {
    colors: [255, 255, 255, 1, 255, 255, 255, 1],
    gradientType: 'linear',
    colorStops: [0, 100]
  },
  // grayscale: radial
  {
    colors: [128, 128, 128, 1, 0, 0, 0, 1],
    gradientType: 'radial',
    colorStops: [0, 100]
  },
  {
    colors: [128, 128, 128, 1, 38, 38, 38, 1],
    gradientType: 'radial',
    colorStops: [0, 100]
  },
  {
    colors: [128, 128, 128, 1, 77, 77, 77, 1],
    gradientType: 'radial',
    colorStops: [0, 100]
  },
  {
    colors: [128, 128, 128, 1, 115, 115, 115, 1],
    gradientType: 'radial',
    colorStops: [0, 100]
  },
  {
    colors: [128, 128, 128, 1, 153, 153, 153, 1],
    gradientType: 'radial',
    colorStops: [0, 100]
  },
  {
    colors: [128, 128, 128, 1, 191, 191, 191, 1],
    gradientType: 'radial',
    colorStops: [0, 100]
  },
  {
    colors: [128, 128, 128, 1, 230, 230, 230, 1],
    gradientType: 'radial',
    colorStops: [0, 100]
  },
  {
    colors: [128, 128, 128, 1, 255, 255, 255, 1],
    gradientType: 'radial',
    colorStops: [0, 100]
  },
  // colors: solid
  {
    colors: [245, 208, 208, 1, 245, 208, 208, 1],
    gradientType: 'linear',
    colorStops: [0, 100]
  },
  {
    colors: [253, 236, 219, 1, 253, 236, 219, 1],
    gradientType: 'linear',
    colorStops: [0, 100]
  },
  {
    colors: [255, 246, 219, 1, 255, 246, 219, 1],
    gradientType: 'linear',
    colorStops: [0, 100]
  },
  {
    colors: [220, 236, 213, 1, 220, 236, 213, 1],
    gradientType: 'linear',
    colorStops: [0, 100]
  },
  {
    colors: [212, 229, 245, 1, 212, 229, 245, 1],
    gradientType: 'linear',
    colorStops: [0, 100]
  },
  {
    colors: [219, 212, 235, 1, 219, 212, 235, 1],
    gradientType: 'linear',
    colorStops: [0, 100]
  },
  {
    colors: [164, 194, 244, 1, 164, 194, 244, 1],
    gradientType: 'linear',
    colorStops: [0, 100]
  },
  {
    colors: [118, 165, 175, 1, 118, 165, 175, 1],
    gradientType: 'linear',
    colorStops: [0, 100]
  },
  // colors: radial
  {
    colors: [245, 208, 208, 1, 245, 208, 208, 1],
    gradientType: 'radial',
    colorStops: [0, 100]
  },
  {
    colors: [253, 236, 219, 1, 240, 169, 99, 1],
    gradientType: 'radial',
    colorStops: [0, 100]
  },
  {
    colors: [255, 246, 219, 1, 250, 210, 92, 1],
    gradientType: 'radial',
    colorStops: [0, 100]
  },
  {
    colors: [220, 236, 213, 1, 147, 188, 129, 1],
    gradientType: 'radial',
    colorStops: [0, 100]
  },
  {
    colors: [212, 229, 245, 1, 112, 164, 213, 1],
    gradientType: 'radial',
    colorStops: [0, 100]
  },
  {
    colors: [219, 212, 235, 1, 145, 128, 187, 1],
    gradientType: 'radial',
    colorStops: [0, 100]
  },
  {
    colors: [164, 194, 244, 1, 112, 164, 213, 1],
    gradientType: 'radial',
    colorStops: [0, 100]
  },
  {
    colors: [211, 211, 211, 1, 118, 165, 175, 1],
    gradientType: 'radial',
    colorStops: [0, 100]
  }
];

export const loftSwatch = [
  ...studioSwatch,
  {
    colors: [10, 132, 130, 255, 5, 43, 51, 255],
    gradientType: 'radial',
    colorStops: [0, 68]
  },
  {
    colors: [0, 28, 84, 1, 0, 0, 0, 1],
    gradientType: 'radial',
    colorStops: [12, 100]
  }
];
